<span class="metric-division">
  <span class="{{isFirstRow ? 'first-row' : 'top-section-wrapper'}}
     {{multiProviderExportPreview.startOfSubsection ? 'first-subsection-option' : 'regular-option'}} general-wrapper">
    <span class="{{multiProviderExportPreview.isMainSection ? 'preview-header' : 'sub-section'}}">{{multiProviderExportPreview.text}}</span>
    <span class="benchmark-wrapper" *ngIf="multiProviderExportPreview.benchmarkOption.length && multiProviderExportPreview.benchmarkPercentile.length">
      <span class="{{'benchmark-text'}} {{'sub-section'}} {{boldBenchmarkClass}}">{{multiProviderExportPreview.benchmarkOption}},</span>
      <span class="{{'percentile-text'}} {{'sub-section'}} {{boldBenchmarkClass}}">{{multiProviderExportPreview.benchmarkPercentile}}</span>
    </span>
  </span>
  <span class="sub-option-wrapper">
    <span *ngFor="let subOption of multiProviderExportPreview.subOptions" class="sub-option">{{subOption}}</span>
  </span>
</span>
